const pl = {
    actionAlready: "Nie zarejestrowany? Zaloguj się",
    actionExit: "Wyloguj się",
    actionLogin: "ZALOGUJ SIĘ",
    actionRegister: "ZAREJESTRUJ SIĘ",
    actionSave: "ZAPISZ",
    actionStart: "ROZPOCZNIJ",
    actionContinue: "KONTYNUUJ",
    actionReset: "RESETUJ OCENĘ",
    actionDoDiagnost: "POKAŻ DIAGNOSTYKĘ",
    actionYes: "Tak",
    actionNo: "Nie",
    actionNext: "DALEJ",
    actionBusinessCase: "POKAŻ DOBRE PRAKTYKI FIRMY",
    actionBusinessCases: "POKAŻ DOBRE PRAKTYKI FIRM",
    actionOpenUrl: "OTWÓRZ LINK",
    actionFilter: "FILTRUJ",

    /** HOME */
    msgHomeTitleOne: "Mierz i zwiększaj poziom dojrzałości cyrkularnej w swojej firmie meblarskiej",
    msgHomeSubTitle: "Narzędzie online FurnCIRCLE ocenia postępy Twojej firmy w kierunku dojrzałości cyrkularnej na podstawie wdrożonych strategii projektowania cyrkularnego",

    msgHomeSection2: "Wymagania cyrkularności rosną.</br>Czy jesteś gotowy?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Odpowiedz na pytania dotyczące strategii projektowania cyrkularnego wdrożonych w Twojej firmie.</li><li>Uzyskaj indeks dojrzałości cyrkularnej swojej firmy.</li><li>Zidentyfikuj strategie projektowe i dobre praktyki firm, które pomogą Ci podnieść poziom cyrkularności Twojej firmy.</li><li>Ucz się na podstawie dobrych praktyk rzeczywistych firm, aby nadal poprawiać poziom dojrzałości cyrkularnej Twojej firmy.</li></ul>",
    msgHomeSection3: "Partnerzy",
    msgHomeSection2Btn: "Rozpocznij swoją ocenę",
    msgHomeSection3Btn: "KONTAKT",

    /** HEADER */
    msgHeader1: "Strategie projektowania cyrkularnego i dobre praktyki",
    msgHeader4: "Zaloguj się",

    /** DRAWER */
    msgCompany: "FIRMA",
    msgDrawer1: "1. Odpowiedz",
    msgDrawer2: "2. Oceń",
    msgDrawer3: "3. Popraw",
    msgDrawer4: "Kolekcja strategii",
    msgDrawer6: "Ustawienia",
    msgDrawer7: "Wyloguj się",

    /** LOGIN */
    msgWelcome: "Witaj",
    msgWelcomeSubtitle: "Proszę, zaloguj się, aby kontynuować",

    /** REGISTER */
    msgGetStarted: "Rozpocznij",
    msgGetStartedSubtitle: "To narzędzie samooceny jest darmowe i poufne",

    msgFirstname: "Imię",
    msgLastname: "Nazwisko",
    msgEmail: "Email",
    msgPassword: "Hasło",
    msgConfirmPassword: "Potwierdź hasło",
    msgCompanyUser: "Firma lub nazwa użytkownika",

    msgNotRegister: "Nie zarejestrowany? <b>Załóż konto tutaj</b>",
    msgAlreadyRegister: "Już zarejestrowany? <b>Zaloguj się tutaj</b>",

    /** HOME TOOL */
    msgClickImage: "Kliknij, aby rozwinąć system modelu liniowego versus cyrkularnego.",

    msgArea: "OBSZAR",
    msgProgress: "ODPOWIEDZI UDZIELONE",

    msgAssessmentAreas: "Strategie projektowania cyrkularnego i cykl życia produktów",
    msgAssessmentDesc: "Strategie projektowania cyrkularnego są stosowane w fazie projektowania i rozwoju produktów, chociaż ich (pozytywny) wpływ może wystąpić w jednej lub więcej późniejszych fazach cyklu życia produktu. Dlatego jednym ze sposobów klasyfikacji strategii projektowania cyrkularnego jest podział według etapu cyklu życia, który jest nimi objęty: projektowanie, zasoby materiałowe, produkcja, dystrybucja, użytkowanie i koniec życia.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Proszę odpowiedzieć na wszystkie pytania dla każdego bloku lub fazy cyklu życia, określić poziom dojrzałości cyrkularnej i zaplanować swoje usprawnienia oraz przejście do bardziej cyrkularnej gospodarki!</span>",

    msgAssessment: "Ocena FurnCIRCLE",
    msgNotApply: "Zaznacz wszystkie odpowiedzi, które dotyczą obecnej wydajności cyrkularnej Twojej firmy. Odpowiedzi są zapisywane automatycznie.",
    msgMarkImportant: "Zaznacz jako ważne",
    msgComment: "Komentarz",
    msgCommentHolder: "Możesz napisać tutaj wszelkie powiązane informacje lub własne komentarze.",

    /** ANSWER */
    msgPerformance: "Raport z oceny",
    msgPerformanceSubtitle: "Sprawdź indeks dojrzałości cyrkularnej swojej firmy oraz każdej fazy cyklu życia produktów.",
    msgCompanyLevel: "Indeks dojrzałości cyrkularnej Twojej firmy (0%-100%)",
    msgBlockArea: "FAZA CYKLU ŻYCIA",
    msgBlockValues: "WARTOŚCI",

    /** ASSESS */
    msgImprovement: "Raport poprawy",
    msgImprovementMainSubtitle: "Dowiedz się, co możesz zrobić, aby stale poprawiać cyrkularność swojej firmy. Poznaj strategie projektowe i dobre praktyki firm, które pomogą Ci podnieść firmę na wyższy poziom.</br></br>Fazy cyklu życia i strategie projektowania cyrkularnego z etykietą/cyrklem „czerwonym” mają poziom wydajności równy lub mniejszy niż 25% ich maksymalnej wartości i dlatego mogą być uznane za priorytet do poprawy cyrkularności firmy. Fazy lub strategie z etykietą/cyrklem „pomarańczowym” mają poziom wydajności wyższy niż 25%, ale mniejszy niż lub równy 75%, dlatego również ważne jest, aby je poprawić. Fazy lub strategie z etykietą/cyrklem „zielonym” mają poziom wydajności wyższy niż 75%, dlatego są mniej priorytetowe do poprawy.",
    msgImprovementSubtitle: "Dowiedz się, co możesz zrobić, aby stale poprawiać cyrkularność swojej firmy. Poznaj strategie projektowe i dobre praktyki firm, które pomogą Ci podnieść firmę na wyższy poziom.",
    msgLifecyclePhases: "Fazy cyklu życia",
    msgLifecycleIndex: "Indeks cyrkularności fazy",
    msgActionsToImplement: "Działania do wdrożenia:",
    msgBaselineScore: "Mój punkt wyjściowy",
    msgBusinessCaseEmpty: "Gratulacje! Już wdrożyłeś główne strategie zawarte w tej kategorii",

    msgCat1: "EKONOMICZNE I ORGANIZACYJNE",
    msgCat2: "SPOŁECZNE",
    msgCat3: "ŚRODOWISKOWE",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Przeglądaj i odkrywaj pełną kolekcję strategii projektowania cyrkularnego i dobrych praktyk firm z projektu FurnCIRCLE.",
    msgLifecyclePhase: "Faza cyklu życia",
    msgDifficulty: "Trudność we wdrożeniu",
    msgBusinessDynamics: "Generowanie lub dostarczanie wartości",
    msgBusinessFactors: "Propozycja wartości / Koszty / Korzyści",

    /** SETTINGS */
    msgUserInfo: "Informacje o użytkowniku",
    msgUserCredentials: "Dane logowania użytkownika",

    /** MODAL */
    msgAreSure: "Jesteś pewny?",

    msgSuccess: "Dane zaktualizowane pomyślnie",
    msgDeleteSuccess: "Dane usunięte pomyślnie",

    /** ALT TEXT */
    msgSaveCommentAlt: "Zapisz “Komentarz”. Nie ma potrzeby zapisywania odpowiedzi na pytania; są one zapisywane automatycznie.",
    msgDifficultyAlt: "Ta etykieta wskazuje trudność wdrożenia strategii projektowania cyrkularnego.",
    msgBusinessBlockAlt: "Ta etykieta wskazuje, który blok biznesowy modelu CANVAS (Generowanie Wartości lub Dostarczanie Wartości) jest dotknięty wdrożeniem strategii projektowania cyrkularnego.",
    msgImpactBlockAlt: "Ta etykieta wskazuje, który blok wpływu modelu CANVAS (Koszty, Korzyści lub Propozycja Wartości) jest dotknięty wdrożeniem strategii projektowania cyrkularnego.",

    /** ERROR */
    errorOblData: "Wypełnij wszystkie obowiązkowe pola",
    errorEmailFormat: "Błąd formatu email",
    errorUserIncorrect: "Błędny email/hasło",
    errorSend: "Błąd komunikacji, proszę poczekać i spróbować później",
    errorLength: "Przekroczono dozwoloną liczbę znaków",
    errorPassSame: "Hasła nie są takie same",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Odzyskiwanie hasła",
    msgRecoveryPasswordSubtitle: "Wprowadź swój adres e-mail, aby otrzymać kod do zresetowania hasła.",
    msgCode: "Kod",
    msgNewPassword: "Nowe hasło",
    actionRequestCode: "POPROŚ O KOD",
    actionUpdate: "AKTUALIZUJ",
    actionBack: "WRÓĆ",
    msgForgetPassword: "Zapomniałeś hasła?",
    errorRecovery: "Błąd podczas odzyskiwania hasła, sprawdź podany kod",

    /** FOOTER */
    msgFooterContact: "KONTAKT",

    msgFooterGr: "Finansowane przez Unię Europejską. Opinie wyrażone przez autora/autorkę nie odzwierciedlają koniecznie stanowiska Unii Europejskiej. Ani Unia Europejska, ani organ udzielający dotacji nie ponoszą odpowiedzialności za te opinie. Numer wezwania i umowy dotacyjnej: SOCPL-2022-SOC-DIALOG-01 (Projekt 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Wszelkie prawa zastrzeżone",

    msgFooterLegal: "Informacje prawne",
    msgFooterPrivacy: "Prywatność",
    msgFooterCookies: "Polityka plików cookie",

    /** PROGRESS VALUES */
    msgProgress0: "Strategie projektowania cyrkularnego",

    /** COMPANY SIZES */
    msgCompanySize: "Wielkość firmy",
    msgCompanySize1: "Mniej niż 10 pracowników",
    msgCompanySize2: "10-30 pracowników",
    msgCompanySize3: "30-50 pracowników",
    msgCompanySize4: "Ponad 50 pracowników",

    /** PRODUCT TYPES */
    msgProductType: "Rodzaj produktów, które produkujesz",
    msgProductType1: "Tapicerka",
    msgProductType2: "Materace",
    msgProductType3: "Podstawy tapicerskie, kanapy, podstawy łóżek",
    msgProductType4: "Podwykonawca (ramy, obróbka, lakierowanie, itp.)",
    msgProductType5: "Usługi (specjalistyczna logistyka, itp.)",
    msgProductType6: "Meble z płyty (melamina, forniry, lakierowanie, itp.)",
    msgProductType7: "Meble drewniane",
    msgProductType8: "Krzesła",
    msgProductType9: "Meble biurowe",
    msgProductType10: "Meble do przestrzeni publicznych i użytkowych",
    msgProductType11: "Drzwi, okna i produkty stolarskie",
    msgProductType12: "Spersonalizowane obiekty (sklepy, biblioteki, restauracje, firmy zawodowe, itp.)",
    msgProductType13: "Oświetlenie",
    msgProductType14: "Powłoki i podłogi",
    msgProductType15: "Tekstylia",
    msgProductType16: "Dekoracje",

    /* COUNTRIES */
    msgCountry: "Kraj",
    msgAfghanistan: "Afganistan",
    msgAlbania: "Albania",
    msgAlgeria: "Algieria",
    msgAmericanSamoa: "Amerykańska Samoa",
    msgAndorra: "Andora",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarktyda",
    msgAntiguaandBarbuda: "Antigua i Barbuda",
    msgArgentina: "Argentyna",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbejdżan",
    msgBahamas: "Bahamy",
    msgBahrain: "Bahrajn",
    msgBangladesh: "Bangladesz",
    msgBarbados: "Barbados",
    msgBelarus: "Białoruś",
    msgBelgium: "Belgia",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermudy",
    msgBhutan: "Bhutan",
    msgBolivia: "Boliwia",
    msgBosniaHerzegovina: "Bośnia i Hercegowina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Wyspa Bouvet",
    msgBrazil: "Brazylia",
    msgBritishIndian: "Brytyjskie Terytorium Oceanu Indyjskiego",
    msgBrunei: "Brunei",
    msgBulgaria: "Bułgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Kambodża",
    msgCameroon: "Kamerun",
    msgCanada: "Kanada",
    msgCapeVerde: "Zielony Przylądek",
    msgCaymanIslands: "Wyspy Kajmańskie",
    msgCentralAfrican: "Republika Środkowoafrykańska",
    msgChad: "Czad",
    msgChile: "Chile",
    msgChina: "Chiny",
    msgChristmasIsland: "Wyspa Bożego Narodzenia",
    msgCocosIslands: "Wyspy Kokosowe (Keeling)",
    msgColombia: "Kolumbia",
    msgComoros: "Komory",
    msgCongo: "Kongo",
    msgRepublicCongo: "Demokratyczna Republika Konga",
    msgCookIslands: "Wyspy Cooka",
    msgCostaRica: "Kostaryka",
    msgIvoryCoast: "Wybrzeże Kości Słoniowej",
    msgCroatia: "Chorwacja",
    msgCuba: "Kuba",
    msgCyprus: "Cypr",
    msgCzechRepublic: "Czechy",
    msgDenmark: "Dania",
    msgDjibouti: "Dżibuti",
    msgDominica: "Dominika",
    msgDominicanRepublic: "Republika Dominikany",
    msgEastTimor: "Timor Wschodni",
    msgEcuador: "Ekwador",
    msgEgypt: "Egipt",
    msgEngland: "Anglia",
    msgElSalvador: "Salwador",
    msgEquatorialGuinea: "Gwinea Równikowa",
    msgEritrea: "Erytrea",
    msgEstonia: "Estonia",
    msgEthiopia: "Etiopia",
    msgFalklandIslands: "Falklandy",
    msgFaroeIslands: "Wyspy Owcze",
    msgFijiIslands: "Wyspy Fidżi",
    msgFinland: "Finlandia",
    msgFrance: "Francja",
    msgFrenchGuiana: "Gujana Francuska",
    msgFrenchPolynesia: "Polinezja Francuska",
    msgFrenchSouthern: "Francuskie Terytoria Południowe",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Gruzja",
    msgGermany: "Niemcy",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grecja",
    msgGreenland: "Grenlandia",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Gwadelupa",
    msgGuam: "Guam",
    msgGuatemala: "Gwatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Gwinea",
    msgGuineaBissau: "Gwinea Bissau",
    msgGuyana: "Gujana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Wyspy Heard i McDonald",
    msgHolySee: "Stolica Apostolska (Watykan)",
    msgHonduras: "Honduras",
    msgHongKong: "Hongkong",
    msgHungary: "Węgry",
    msgIceland: "Islandia",
    msgIndia: "Indie",
    msgIndonesia: "Indonezja",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Irlandia",
    msgIsrael: "Izrael",
    msgIsleMan: "Wyspa Man",
    msgItaly: "Włochy",
    msgJamaica: "Jamajka",
    msgJapan: "Japonia",
    msgJersey: "Jersey",
    msgJordan: "Jordania",
    msgKazakhstan: "Kazachstan",
    msgKenya: "Kenia",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuwejt",
    msgKyrgyzstan: "Kirgistan",
    msgLaos: "Laos",
    msgLatvia: "Łotwa",
    msgLebanon: "Liban",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Libijska Dżamahirija Arabska",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Litwa",
    msgLuxembourg: "Luksemburg",
    msgMacao: "Macao",
    msgNorthMacedonia: "Macedonia Północna",
    msgMadagascar: "Madagaskar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malezja",
    msgMaldives: "Malediwy",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Wyspy Marshalla",
    msgMartinique: "Martynika",
    msgMauritania: "Mauretania",
    msgMauritius: "Mauritius",
    msgMayotte: "Majotta",
    msgMexico: "Meksyk",
    msgMicronesia: "Mikronezja, Stany Federacyjne",
    msgMoldova: "Mołdawia",
    msgMonaco: "Monako",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Czarnogóra",
    msgMorocco: "Maroko",
    msgMozambique: "Mozambik",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Holandia",
    msgNetherlandsAntilles: "Antyle Holenderskie",
    msgNewCaledonia: "Nowa Kaledonia",
    msgNewZealand: "Nowa Zelandia",
    msgNicaragua: "Nikaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Wyspa Norfolk",
    msgNorthKorea: "Korea Północna",
    msgNorthernIreland: "Irlandia Północna",
    msgNorthernMariana: "Wyspy Północno-Marianne",
    msgNorway: "Norwegia",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestyna",
    msgPanama: "Panama",
    msgPapua: "Papua-Nowa Gwinea",
    msgParaguay: "Paragwaj",
    msgPeru: "Peru",
    msgPhilippines: "Filipiny",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polska",
    msgPortugal: "Portugalia",
    msgPuertoRico: "Portoryko",
    msgQatar: "Katar",
    msgReunion: "Reunion",
    msgRomania: "Rumunia",
    msgRussianFederation: "Federacja Rosyjska",
    msgRwanda: "Rwanda",
    msgSaintHelena: "Święta Helena",
    msgSaintKitts: "Saint Kitts i Nevis",
    msgSaintLucia: "Saint Lucia",
    msgSaintPierre: "Saint Pierre i Miquelon",
    msgSaintVincent: "Saint Vincent i Grenadyny",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Sao Tome i Principe",
    msgSaudiArabia: "Arabia Saudyjska",
    msgScotland: "Szkocja",
    msgSenegal: "Senegal",
    msgSerbia: "Serbia",
    msgSeychelles: "Seszele",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapur",
    msgSlovakia: "Słowacja",
    msgSlovenia: "Słowenia",
    msgSolomonIslands: "Wyspy Salomona",
    msgSomalia: "Somalia",
    msgSouthAfrica: "Południowa Afryka",
    msgSouthSandwich: "Wyspy Georgii Południowej i Sandwich Południowy",
    msgSouthKorea: "Korea Południowa",
    msgSouthSudan: "Sudan Południowy",
    msgSpain: "Hiszpania",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudan",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard i Jan Mayen",
    msgSwaziland: "Suazi",
    msgSweden: "Szwecja",
    msgSwitzerland: "Szwajcaria",
    msgSyria: "Syria",
    msgTajikistan: "Tadżykistan",
    msgTanzania: "Tanzania",
    msgThailand: "Tajlandia",
    msgTimorLeste: "Timor-Leste",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trynidad i Tobago",
    msgTunisia: "Tunezja",
    msgTurkey: "Turcja",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Turks i Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ukraina",
    msgUnitedArabEmirates: "Zjednoczone Emiraty Arabskie",
    msgUnitedKingdom: "Wielka Brytania",
    msgUnitedStates: "Stany Zjednoczone",
    msgUnitedStatesMinor: "Mniejsze Wyspy Zamorskie Stanów Zjednoczonych",
    msgUruguay: "Urugwaj",
    msgUzbekistan: "Uzbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Wenezuela",
    msgVietnam: "Wietnam",
    msgVirginIslandsBritish: "Brytyjskie Wyspy Dziewicze",
    msgVirginIslandsUS: "Wyspy Dziewicze USA",
    msgWales: "Walia",
    msgWallisFutuna: "Wallis i Futuna",
    msgWesternSahara: "Sahara Zachodnia",
    msgYemen: "Jemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",
}

export default pl;